import { render, staticRenderFns } from "./BillDeleteApproval.vue?vue&type=template&id=18e0e3ea"
import script from "./BillDeleteApproval.vue?vue&type=script&lang=js"
export * from "./BillDeleteApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports